"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _FlatSaleCallbackBanner = require("./FlatSaleCallbackBanner");
Object.keys(_FlatSaleCallbackBanner).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _FlatSaleCallbackBanner[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _FlatSaleCallbackBanner[key];
    }
  });
});